export const QuestionTypes = Object.freeze({
  MULTIPLE_CHOICE_QUESTION: 'multipleChoiceQuestionType',
  RATING_QUESTION: 'ratingQuestionType',
  TEXT_QUESTION: 'textQuestionType',
});

export default QuestionTypes;
